module.exports = __webpack_public_path__ + "assets/collector-mobile.28d765ba6f4e75dafff2f7324955fc28.png";